import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import 'firebase/storage';
import 'firebase/firestore'

// check carefully before releasing to production
export const firebaseConfig = {
  // prod config  
  // apiKey: "AIzaSyDhpbM6ACXSm-0uxhZv9QoKD1agiKRb0lU",
  // authDomain: "oneimpact-next-generation.firebaseapp.com",
  // databaseURL: "https://oneimpact-next-generation-default-rtdb.firebaseio.com",
  // projectId: "oneimpact-next-generation",
  // storageBucket: "oneimpact-next-generation.appspot.com",
  // messagingSenderId: "775853039219",
  // appId: "1:775853039219:web:b86f2c995557bc1016d406",
  // measurementId: "G-SBVYDYFV3G",
  // serverKey: "AAAAtKRx3nM:APA91bGb5cuIA3C3WrIsn8WrQKy9UQ0UD-eOmkuOxdvW2TLRQsnKZXAADugq5ogReRRvAN_9bJKpsBClliNo7lkGX7akGAKWaMUUFluiEckluNZoYsDSywpN27d_qKCfxg1kTSXdsz9K"

  
  // uat config  
  // googleMapKey:"AIzaSyAk4_RjGS0QBVi6Waj-f2Qd0bK3gxuL4FU",
  // apiKey: "AIzaSyC4ON4dUgE5fCBpwsouz2oND_ZRHcKcjPM",
  // authDomain: "oneimpact-uat.firebaseapp.com",
  // databaseURL: "https://oneimpact-uat-default-rtdb.firebaseio.com",
  // projectId: "oneimpact-uat",
  // storageBucket: "oneimpact-uat.appspot.com",
  // messagingSenderId: "613909026961",
  // appId: "1:613909026961:web:9500417d4e24813b6b4730",
  // measurementId: "G-GG6YZCD5RV",
  // serverKey: "AAAAju_UWJE:APA91bGaHfz1eKzxovr13lkS-F7XQJ8yhggS4i3E2cKC4iMKAqIbf4OoT2yUeToGtT7orvP9QPMB3spVNmBelj3Mx3TvwIfc9wVS5ffk21Uo6uvkwgL_gfUCgCgtFI2VqvhJulUwD9SP"

  //uat
  googleMapKey:"AIzaSyAk4_RjGS0QBVi6Waj-f2Qd0bK3gxuL4FU",
  apiKey: "AIzaSyDQbU0X_vcCD9Ns0oLZwzIyprtz8Z22N08",
  authDomain: "undp-tpt.firebaseapp.com",
  databaseURL: "https://undp-tpt-default-rtdb.firebaseio.com",
  projectId: "undp-tpt",
  storageBucket: "undp-tpt.appspot.com",
  messagingSenderId: "1064495788398",
  appId: "1:1064495788398:web:4719e9d01faf38ae88d17f",
  measurementId: "G-WK2734NKGC",
  serverKey: "AAAA99jksW4:APA91bFa6OFyoO5zGub41Ya9AVQ7loh0um43YYOOBrzlD6ANa6Jii5t2sce8O9kvpl7WLi-4_Ce5TW6FEG2gTgUYajfMwISP1OMK_ZBsN0Mzis-aGtSRNvbR6tgHMMMCfK3vYjxwgB0D"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth;
export const db = firebase.database();
export const storageRef = firebase.storage();
export const store = firebase.firestore()
